module.exports = __webpack_public_path__ + "static/img/file_img.263fc72c.png";